<ng-container *ngIf="profile_id==11">
  {{'account.superAdministrator' | translate}}
</ng-container>
<ng-container *ngIf="profile_id==12 || profile_id== 1">
  {{'account.siteAdministrator' | translate}}
</ng-container>
<ng-container *ngIf="profile_id==2 || profile_id==4 || profile_id==5 || profile_id==6 || profile_id==9 || profile_id==10">
  {{'account.supervisor' | translate}}
</ng-container>
<ng-container *ngIf="profile_id==14 || profile_id== 3">
  {{'account.learner' | translate}}
</ng-container>
